<template lang="pug">
.tree-slider(ref="treeSlider" :class="[labelPosition]")
  .background(:style="{ 'maskImage': `linear-gradient(90deg,   rgb(0 0 0 / 25%) ${percentage}%, ${percentage}%, black)` }")
    GammaIcon(:src="getIconFromCSS('tree')" :default-src="TreeIcon" v-for="i in treesCount" :key="i")
  .slider(:style="{width: `${percentage}%`}" :class="{'near-end': berRating.value > 450, 'near-start': berRating.value < 60}")
    .slider-info
      .label {{ sliderLabel }}  
      BerRatingInfo(v-if="berRating" :rating="berRating")
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref} from "vue";
import BerRatingInfo from "@/components/result/BERRatingInfo.vue";
import {Rating} from "@/types";
import {getIconFromCSS, getWidthPercentage} from "@/helpers";
import GammaIcon from "@/components/icons/GammaIcon.vue";
import TreeIcon from "@/components/icons/carbon-footprint/tree-icon.vue";

export default defineComponent({
  components: {
    BerRatingInfo,
    GammaIcon,
    TreeIcon,
  },
  props: {
    treesCount: {
      type: Number,
      required: true,
    },
    sliderLabel: String,
    labelPosition: {
      type: String as PropType<"top" | "bottom">,
      default: "top",
    },
    berRating: {
      type: Object as PropType<Rating>,
      required: true,
    },
  },
  setup(props) {
    const treeSlider = ref<HTMLDivElement | undefined>(undefined);
    const percentage = computed(() =>
        Math.max(0, Math.min(100, getWidthPercentage(props.berRating.value)))
    );

    return {
      treeSlider,
      percentage,
      getIconFromCSS,
      TreeIcon,
    };
  },
});
</script>

<style scoped lang="scss">
.tree-slider {
  height: 10rem;
  margin: auto auto auto 0;
  width: 100%;
  position: relative;
  display: flex;
  align-items: flex-end;

  &.bottom {
    align-items: flex-start;

    .slider {
      align-items: flex-end;
    }
  }

  .background {
    display: flex;
    width: 100%;
    margin: 1rem 0;

    & > svg {
      flex: 1;
    }
  }

  .slider {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    gap: 0.5rem;
    height: 100%;
    border-right: 1px solid black;
    transition: all 250ms linear;

    .slider-info {
      padding: 0.5rem 0;
      display: flex;
      gap: 0.5rem;
    }

    &.near-start,
    &.near-end {
      .slider-info {
        .label {
          position: initial;
        }

        .ber-rating-info {
          transform: none;
          margin-right: 0.5rem;
        }
      }
    }

    &.near-start {
      .slider-info {
        transform: translatex(calc(100% + 0.75rem));
      }
    }

    .slider-info {
      .label {
        position: absolute;
        right: 0.75rem;
        padding: 0.25rem 0;
        color: $primary-color;
        font-weight: 600;
        font-size: 1.2rem;
      }

      .ber-rating-info {
        height: fit-content;
        width: 7rem;
        transform: translatex(calc(100% + 0.75rem));
      }
    }
  }
}
</style>
